import { mapState } from 'vuex';
import { mapActions } from 'vuex';

import { ESTADOS } from '../../util/constantes';

import AppGravarCondominioDialog from './dialogs/GravarCondominioDialog.vue';

export default {
  components: {
    AppGravarCondominioDialog
  },
  data() {
    return {
      infiniteLoadingId: 0,
      validacao: {
        nome: [
          { required: true, message: "Nome é obrigatório" }
        ]
      },
      visibilidadeGravarCondominioDialog: false,

      tabSelecionada: 'detalhes',

      hoverGravar: false,
      hoverRemover: false,
    };
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "ADMINISTRADORAS"
          })[0];
      }
    }),
    ...mapState('administradorasStore', {
      administradoras(state) { return state.listaAdministradoras },
      administradoraPesquisa(state) { return state.administradoraPesquisa },
      labelQuantidade(state) { return state.labelQuantidade },
      administradora(state) { return state.administradoraSelecionada }
    }),
    estados() {
      return ESTADOS.filter(estado => { return estado.pais.id === 1 });
    },
    exibirAdministradoras() {
      return this.permissoes.visualizacao === true;
    },
    exibirBotaoGravarAdministradora() {
      return(
        (this.administradora.id === 0 && this.permissoes.cadastro)
        || (this.administradora.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverAdministradora() {
      return this.administradora.id != 0 && this.permissoes.remocao;
    },
    exibirBotaoAdicionarCondominio() {
      return this.administradora.id != 0 && this.permissoes.alteracao;
    },
    exibirBotaoRemoverCondominio() {
      return this.permissoes.alteracao;
    }
  },
  methods: {
    ...mapActions('administradorasStore', [
      'listarAdministradoras',
      'limparAdministradorasListadas',
      'limparAdministradoraPesquisa',
      'recuperarAdministradora',
      'novaAdministradora',
      'gravarAdministradora',
      'removerAdministradora',
      'removerCondominio'
    ]),
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    pesquisarHandler() {
      this.administradoraPesquisa.pagina = 0;
      this.limparAdministradorasListadas();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if(this.administradoraPesquisa.pagina === 0) { this.showLoading(); }
      this.listarAdministradoras(this.administradoraPesquisa).then((resultado) => {
        if(this.administradoraPesquisa.pagina === 0) { this.hideLoading(); }
        if(resultado.lista.length == 100) {
          this.administradoraPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.administradoraPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        if(this.administradoraPesquisa.pagina === 0) { this.hideLoading(); }
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },
    novaAdministradoraHandler() {
      this.$refs["form"].resetFields();
      this.novaAdministradora();
    },
    limparPesquisa() {
      this.limparAdministradoraPesquisa();
    },
    recuperarHandler(administradora) {
      this.recuperar(administradora);
    },
    recuperar(administradora) {
      this.showLoading();
      this.recuperarAdministradora(administradora).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      })
    },
    gravar() {
      this.showLoading();
      this.gravarAdministradora(this.administradora).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    removerAdministradoraHandler() {
      this.$confirm('Deseja realmente remover esta administradora?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.remover();
      }).catch(() => {});
    },
    remover() {
      this.showLoading();
      this.removerAdministradora(this.administradora).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    exibirGravarCondominioDialog() {
      this.visibilidadeGravarCondominioDialog = true;
    },
    fecharGravarCondominioDialog() {
      this.visibilidadeGravarCondominioDialog = false;
    },
    removerCondominioHandler(condominio) {
      this.$confirm('Deseja mesmo remover este Condomínio dessa Administradora?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
          this.removerCondominioDaAdministradora(condominio);
        }).catch(() => {});
    },
    removerCondominioDaAdministradora(condominio) {
      this.showLoading();
      this.removerCondominio(condominio).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);   
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      })
    }
  }
}